import { ElementType } from 'react';

import * as actions from './actions';
import store from '.';
import { BaseTicket, CustomCompMessage, ImageState, Link, LinkParams, MessageTypes } from './types';

export function addUserMessage(text: string, id?: string) {
  store.dispatch(actions.addUserMessage(text, id));
}

export function addResponseMessage(text: string, id?: string) {
  store.dispatch(actions.addResponseMessage(text, id));
}

export function addLinkSnippet(link: LinkParams, id?: string) {
  store.dispatch(actions.addLinkSnippet(link, id));
}

export function toggleMsgLoader() {
  store.dispatch(actions.toggleMsgLoader());
}

export function renderCustomComponent(component: ElementType, props: any, showAvatar = false, id?: string) {
  store.dispatch(actions.renderCustomComponent(component, props, showAvatar, id));
}

export function toggleWidget() {
  store.dispatch(actions.toggleChat());
}

export function toggleTickets() {
  store.dispatch(actions.toggleTickets());
}

export function toggleInputDisabled() {
  store.dispatch(actions.toggleInputDisabled());
}

export function setMessages(messages: (MessageTypes | Link | CustomCompMessage)[]) {
  store.dispatch(actions.setMessages(messages));
}

export function getMessages(): (MessageTypes | Link | CustomCompMessage)[] {
  return store.getState().messages.messages;
}

export function dropMessages() {
  store.dispatch(actions.dropMessages());
}

export function isWidgetOpened(): boolean {
  return store.getState().behavior.showChat;
}

export function setQuickButtons(buttons: Array<{ label: string, value: string | number }>) {
  store.dispatch(actions.setQuickButtons(buttons));
}

export function deleteMessages(count: number, id?: string) {
  store.dispatch(actions.deleteMessages(count, id));
}

export function markAllAsRead() {
  store.dispatch(actions.markAllMessagesRead());
}

export function setBadgeCount(count: number) {
  store.dispatch(actions.setBadgeCount(count));
}

export function openFullscreenPreview(payload: ImageState) {
  store.dispatch(actions.openFullscreenPreview(payload));
}

export function closeFullscreenPreview() {
  store.dispatch(actions.closeFullscreenPreview());
}

export function setTickets(tickets: BaseTicket[]) {
  store.dispatch(actions.setTickets(tickets));
}
